export const SETTINGS_ROUTE = '/settings';
